import * as React from 'react';
import { type Theme, useStyletron } from 'baseui';
import { KEYPOINTS_PANEL } from '../../../constants/template-builder';
import type { KeypointItemT } from '../../../types/annotations.type';
import { KeypointRow } from './keypoint-row';
import { KeypointsEmptyState } from './keypoints-empty-state';
type KeypointsSidePanelPropsT = {
  keypoints: KeypointItemT[];
  selectedKeypointId?: string | null;
  onDeleteKeypoint?: (id: string) => void;
  onColorChange?: (id: string, color: string) => void;
};
const getContainerStyles = (theme: Theme) => ({
  display: ('flex' as const),
  flexDirection: ('column' as const),
  width: KEYPOINTS_PANEL.WIDTH_PERCENTAGE,
  minWidth: KEYPOINTS_PANEL.MIN_WIDTH,
  overflow: ('hidden' as const),
  backgroundColor: theme.colors.backgroundPrimary,
  borderLeft: `1px solid ${theme.colors.borderOpaque}`,
  boxSizing: ('border-box' as const)
});
const getHeadingContainerStyles = (theme: Theme) => ({
  padding: theme.sizing.scale600
});
const getHeadingStyles = (theme: Theme) => ({
  ...theme.typography.HeadingXSmall,
  margin: '0'
});
const getDividerStyles = (theme: Theme) => ({
  borderBottom: `1px solid ${theme.colors.borderOpaque}`
});
const getListStyles = (theme: Theme) => ({
  display: ('flex' as const),
  flexDirection: ('column' as const),
  flex: 1,
  overflowY: ('auto' as const),
  paddingBottom: theme.sizing.scale600,
  scrollbarWidth: ('none' as const),
  msOverflowStyle: ('none' as const),
  '::-webkit-scrollbar': {
    display: 'none'
  }
});
const getRowDividerStyles = (theme: Theme) => ({
  height: '1px',
  backgroundColor: theme.colors.borderOpaque,
  marginLeft: theme.sizing.scale1600
});
export function KeypointsSidePanel({
  keypoints,
  selectedKeypointId,
  onDeleteKeypoint,
  onColorChange
}: KeypointsSidePanelPropsT) {
  const [css, theme] = useStyletron();
  return <div className={css(getContainerStyles(theme))} data-testid="keypoints-side-panel">
      <div className={css(getHeadingContainerStyles(theme))}>
        <div className={css(getHeadingStyles(theme))}>
          {KEYPOINTS_PANEL.HEADING} ({keypoints.length})
        </div>
      </div>

      <div className={css(getDividerStyles(theme))} />

      {keypoints.length === 0 ? <KeypointsEmptyState /> : <div className={css(getListStyles(theme))} data-testid="keypoints-list">
          {keypoints.map((keypoint, index) => <React.Fragment key={keypoint.id}>
              {index > 0 && <div className={css(getRowDividerStyles(theme))} />}
              <KeypointRow keypoint={keypoint} isSelected={keypoint.id === selectedKeypointId} onDelete={onDeleteKeypoint} onColorChange={onColorChange} />
            </React.Fragment>)}
        </div>}
    </div>;
}